import { render } from "./elem-password.vue?vue&type=template&id=20c4225a&ts=true"
import script from "./elem-password.vue?vue&type=script&lang=ts"
export * from "./elem-password.vue?vue&type=script&lang=ts"

import "./elem-password.vue?vue&type=style&index=0&id=20c4225a&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__